import { DeliveryChargeRuleScope, IDeliveryChargeRule } from "../components/delivery-company-components/merchants/delivery-charge-rules/interfaces";
import { getGovernorateForDistrict } from "../data/regions";
import { ILocation } from "../interfaces/common/location";

export const deliveryChargeRuleApplies = (rule: IDeliveryChargeRule, location?: ILocation | null): boolean => {
    if (location == undefined || location.area == undefined) 
            return false


    return (rule.scope == DeliveryChargeRuleScope.AREA && location.area.id == rule.area!.id ) ||
    (rule.scope == DeliveryChargeRuleScope.DISTRICT && location.area.district == rule.district ) ||
    (rule.scope == DeliveryChargeRuleScope.GOVERNORATE && getGovernorateForDistrict(location.area.district) == rule.governorate)
}